import cn from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, ReactNode } from "react";
import styled from "styled-components";

const StyledHeaderLinkNew = styled.div`
  display: flex;
  align-items: center;

  &.HeaderLinkNew_active {
    .HeaderLinkNew__anchor {
      background: #fff4c7;
      font-weight: bold;
      color: ${({ theme }) => theme.colors.black};
    }
  }

  .HeaderLinkNew__anchor {
    padding: 7px 14px;

    font-weight: normal;
    font-size: 14px;
    line-height: 18px;

    color: #8a867c;
    text-decoration: none;

    border-radius: 10px;
  }
`;

interface Props {
  children?: ReactNode;
  href: string;
}

const HeaderLinkNew: FC<Props> = ({ href, children }) => {
  const { asPath } = useRouter();
  const isActive = asPath.startsWith(href);

  return (
    <StyledHeaderLinkNew className={cn({ HeaderLinkNew_active: isActive })}>
      <Link href={href}>
        <a className="HeaderLinkNew__anchor">{children}</a>
      </Link>
    </StyledHeaderLinkNew>
  );
};

export { HeaderLinkNew };
